import React from "react";

const UnPlane = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
              d="M27.019 19.141a9.06 9.06 0 0 1 4.603 1.25v-10.6L23.95 2H5.532A1.54 1.54 0 0 0 4 3.546V31.62c0 .836.683 1.546 1.524 1.546h13.52a9.417 9.417 0 0 1-1.233-4.675c0-5.164 4.123-9.35 9.208-9.35Zm5.425 12.655-3.255-3.305 3.255-3.306-2.17-2.204-3.255 3.306-3.255-3.306-2.17 2.204 3.255 3.306-3.256 3.305L23.763 34l3.256-3.306L30.274 34l2.17-2.204Z"
              fill={fill}
        />
    </svg>
);

export default UnPlane;
